import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  actions: {
    '& > .MuiButton-root': {
      width: '100%',
    },
  },
}));
